import { Entity } from '@api';
import { Drawer } from '@design';
import { DrawerContentWrapper } from '@terminal/components/drawer-content-wrapper/DrawerContentWrapper';
import { CompanyToGeoWidget } from '@terminal/widgets/company-to-geo-widget/CompanyToGeoWidget';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './GeographicExposureDrawer.module.scss';
import { useGeographicDrawer } from './useGeographicDrawer';

export const DRAWER_GEOGRAPHIC_EXPOSURE = 'geographicExposure';

export interface GeographicExposureDrawerProps {
  entity: Entity;
}

export const GeographicExposureDrawer = ({
  entity,
}: GeographicExposureDrawerProps) => {
  const { closeDrawer, isDrawerOpen, type, countryCode, regionName } =
    useGeographicDrawer();
  const { t } = useTranslation(['countries']);

  const getHeaderLabel = () => {
    if (type === 'country' && countryCode) {
      return t(`countries:${countryCode.toUpperCase()}`);
    }

    if (type === 'region' && regionName) {
      return regionName;
    }

    return '';
  };

  const headerLabel = getHeaderLabel();

  if (!type) {
    return null;
  }

  return (
    <Drawer
      data-testid="geographic-exposure-drawer"
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      headerButton={<div className={styles.headerTitle}>{headerLabel}</div>}
    >
      <DrawerContentWrapper>
        <CompanyToGeoWidget entity={entity} />
      </DrawerContentWrapper>
    </Drawer>
  );
};
